import type { Breadcrumb, RecordedReport, Reporter, Tags } from "./types";

/** A reporter that keeps errors in memory. For package tests, E2E and Storybook. */
export function recordingReporter(): Reporter & { readonly reports: readonly RecordedReport[] } {
  const reports: RecordedReport[] = [];
  const breadcrumbs: Breadcrumb[] = [];
  let userId: string | null = null;
  let scopeTags: Tags = {};
  return {
    reports,
    init: () => {},
    captureException: (report) => {
      // As Sentry does, an error's own tags win over the scope's.
      reports.push({ ...report, tags: { ...scopeTags, ...report.tags }, userId, breadcrumbs: [...breadcrumbs] });
    },
    addBreadcrumb: (breadcrumb) => {
      breadcrumbs.push(breadcrumb);
    },
    setUser: (user) => {
      userId = user?.userId ?? null;
    },
    setTags: (tags) => {
      scopeTags = Object.fromEntries(
        Object.entries({ ...scopeTags, ...tags }).filter((entry): entry is [string, string] => entry[1] !== null),
      );
    },
  };
}
